import { render } from "./PortCard.vue?vue&type=template&id=7413085b&scoped=true"
import script from "./PortCard.vue?vue&type=script&lang=js"
export * from "./PortCard.vue?vue&type=script&lang=js"

import "./PortCard.vue?vue&type=style&index=0&id=7413085b&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7413085b"]])

export default __exports__